import { REQUEST_METHOD } from '@/constants';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { apiInstance } from '@/utils';

export type JobPostingConfig = {
  id: number;
  vendor_id: number;
  config_name: string;
  companies: { identifier: string; value: string[] } | null;
  title: string[];
  technologies: string[];
  job_functions: string[];
  industries: string[];
  seniority_level: string[];
  employment_type: string[];
  job_location_type: string[];
  country_or_region_code: string[];
  annual_salary_usd: { lowerBound: number | null; upperBound: number | null } | null;
  years_of_experience: { lowerBound: number | null; upperBound: number | null } | null;
  num_applicants: { lowerBound: number | null; upperBound: number | null } | null;
  posted_at: { strategy: string; range: { lowerBound: string; upperBound: string } } | null;
  job_posting_is_active: string | null;
  page_size: number;
  is_active: boolean;
  last_run_at: string | null;
  next_run_at: string | null;
  created_at: string;
  updated_at: string;
};

export type JobPostingConfigInput = {
  config_name: string;
  companies?: { identifier: string; value: string[] } | null;
  title?: string[];
  technologies?: string[];
  job_functions?: string[];
  industries?: string[];
  seniority_level?: string[];
  employment_type?: string[];
  job_location_type?: string[];
  country_or_region_code?: string[];
  annual_salary_usd?: { lowerBound: number | null; upperBound: number | null } | null;
  years_of_experience?: { lowerBound: number | null; upperBound: number | null } | null;
  num_applicants?: { lowerBound: number | null; upperBound: number | null } | null;
  posted_at?: { strategy: string; range: { lowerBound: string; upperBound: string } } | null;
  job_posting_is_active?: string | null;
  page_size?: number;
  is_active?: boolean;
};

type JobPostingConfigsResponse = {
  configs: JobPostingConfig[];
};

type JobPostingConfigResponse = {
  config: JobPostingConfig;
};

export const getJobPostingConfigs = async (): Promise<JobPostingConfigsResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: API_ENDPOINTS.jobPostingConfigs,
  });

  return result.data;
};

export const getJobPostingConfig = async (configId: number): Promise<JobPostingConfigResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: `${API_ENDPOINTS.jobPostingConfigs}/${configId}`,
  });

  return result.data;
};

export const createJobPostingConfig = async (
  data: JobPostingConfigInput,
): Promise<JobPostingConfigResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.POST,
    url: API_ENDPOINTS.jobPostingConfigs,
    data,
  });

  return result.data;
};

export const updateJobPostingConfig = async (
  configId: number,
  data: JobPostingConfigInput,
): Promise<JobPostingConfigResponse> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.PUT,
    url: `${API_ENDPOINTS.jobPostingConfigs}/${configId}`,
    data,
  });

  return result.data;
};

export const deleteJobPostingConfig = async (configId: number): Promise<{ success: boolean }> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.DELETE,
    url: `${API_ENDPOINTS.jobPostingConfigs}/${configId}`,
  });

  return result.data;
};

